import appClasses from "@/app/app.module.scss";
import classNames from "classnames";
import TextInput from "@/components-library/widgets/text-nput";
import { useRef } from "react";
import Button from "@/components-library/widgets/button";
import Flex from "@/components-library/layout/flex";
import classes from "./file-input.module.scss";

function FileInput({
  label,
  name,
  fileName,
  onFileUpload,
  onFileDeletion,
  accept,
  multiple,
  className,
  withDeleteButton,
}) {
  const fileRef = useRef();

  const handleFileChange = (event) => {
    if (!!event.target.files.length) {
      onFileUpload(event);
    }
  };

  const handleFileDeletion = () => {
    onFileDeletion(fileName);
  };

  return (
    <Flex direction="row" justify="flex-start" align="flex-end">
      <TextInput
        label={label ?? "image"}
        type="text"
        className={classNames(
          appClasses.overrideTextField,
          classes.textInput,
          className ?? ""
        )}
        name={name ?? "file"}
        value={fileName ?? ""}
        disabled={true}
        wrapperProps={{
          onClick: function (event) {
            fileRef.current.click();
          },
        }}
      />
      <input
        type="file"
        onChange={handleFileChange}
        hidden
        ref={fileRef}
        accept={accept ?? "*"}
        multiple={multiple ?? false}
      />

      {withDeleteButton && fileName && (
        <Button
          color="primary"
          className={classes.button}
          onClick={handleFileDeletion}
        >
          Delete
        </Button>
      )}

      <Button
        color="primary"
        className={classes.button}
        onClick={() => fileRef.current.click()}
      >
        Select File
      </Button>
    </Flex>
  );
}
export default FileInput;
